import { render, staticRenderFns } from "./ClassTeacherList.vue?vue&type=template&id=231f7871&scoped=true"
import script from "./ClassTeacherList.vue?vue&type=script&lang=js"
export * from "./ClassTeacherList.vue?vue&type=script&lang=js"
import style0 from "./ClassTeacherList.vue?vue&type=style&index=0&id=231f7871&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231f7871",
  null
  
)

export default component.exports